import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { Store } from '@ngrx/store';
import * as fromHome from '../../state';
import * as fromRoot from '../../../state';
import { Router } from '@angular/router';

@Component({
  selector: 'anms-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent implements OnInit {
  currentUser$: Observable<MiniUserModel>;
  isAuthenticated$: Observable<boolean>;

  constructor(private store$: Store<fromHome.State>, private router: Router) {}

  ngOnInit(): void {
    this.currentUser$ = this.store$.select(fromRoot.getMe);
    this.isAuthenticated$ = this.store$.select(fromRoot.getIsAuthenticated);
  }
}
